enum MessageFileType {
  TYPE_NONE = 0,
  TYPE_IMAGE = 1,
  TYPE_FILE = 2
}

export default MessageFileType;
